<div class="blur-page" *ngIf="disabledRegistration"><prl-label value="registration.disabled.label"/></div>
<mx-preloader preloaderName="registration"></mx-preloader>
<mx-object-form (customize)="onCustomize($event)" class="multiple-columns">
    <ng-template mxFormField="userName" mxFormFieldPlacement="replace" let-form="form" let-field="field">
        <mx-text-field [form]="form"
                       [name]="field.name"
                       [label]="field.label"
                       [matTooltip]="usernameTooltip"
                       matTooltipPosition="above">
        </mx-text-field>
    </ng-template>
    <ng-template mxFormField="recaptcha" mxFormFieldPlacement="replace" let-form="form">
        <re-captcha [siteKey]="captchaKey"
                    (resolved)="resolved($event)"
                    formControlName="recaptcha"
                    required>
        </re-captcha>
        <div *ngIf="form.controls['recaptcha'].touched">
            <mat-error *ngIf="form.controls['recaptcha'].value === null">
                <prl-label value="label.errors.mandatory"></prl-label>
            </mat-error>
        </div>
    </ng-template>
</mx-object-form>

